import generateId from 'lib/generateId';

export const USER_CREATE = 'user/CREATE';
export const USER_CREATE_SUCCESS = 'user/CREATE_SUCCESS';
export const USER_UPDATE = 'user/UPDATE';
export const USER_UPDATE_SUCCESS = 'user/UPDATE_SUCCESS';
export const USER_AUTH = 'user/AUTH_USER';

export const userEventTypes = {
  USER_CREATE,
  USER_CREATE_SUCCESS,
  USER_UPDATE,
  USER_UPDATE_SUCCESS,
  USER_AUTH,
};

export const updateUser = ({ name, email }) => ({ type: USER_UPDATE, payload: { name, email } });

export const createOnboardingUser = ({ name, email }) => ({
  type: USER_CREATE,
  payload: { id: generateId(), name, email, hasOnboarded: true },
});

export const createEmptyUser = () => ({
  type: USER_CREATE,
  payload: { id: generateId() },
});

export default {
  createEmptyUser,
  createOnboardingUser,
  updateUser,
};
